import { utils } from '@flipbyte/formik-json';
import _ from 'lodash';
import React from 'react';
import { changeHandler, joinNames } from '../utils0'
import MaskedInput from 'react-text-mask'

const CustomDate = ({ config, formik, value = '', error }) => {
    const {
        name,
        label,
        type,
        attributes,
        fieldType,
        defaultValue,
        icon,
        labelClass = '',
        fieldClass = 'form-control',
        formGroupClass = 'form-group'
    } = config;

    const { setFieldValue, handleChange, handleBlur } = formik;
    const isInputGroup = icon ? true : false;
    const currentValue = value;


    return (
        <React.Fragment>
            
            <MaskedInput

                id={ name }
                name={ name }
                type={ fieldType }
                tabIndex={ attributes.tabindex } 
                className={ fieldClass + ( error ? ' is-invalid ' : '' ) }
                value={ currentValue }
                onChange={ changeHandler.bind(this, handleChange, formik, config) }
                onBlur={ handleBlur }

                mask={[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]}

                placeholder="eg 20-01-20"
                guide={false}

                />
            
        </React.Fragment>
    );
}

export default CustomDate; 